import React, { useEffect } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import PageLoading from 'components/PageLoading';
import Content from 'containers/TransmissionReport/Content';

const TransmissionReport = ({ fetchReportItem, loading, match }) => {
  useEffect(() => {
    fetchReportItem({ id: match.params.reportId });
  }, [fetchReportItem, match.params.reportId]);

  if (loading) {
    return <PageLoading />;
  }

  return <Content reportId={match.params.reportId} />;
};

TransmissionReport.propTypes = {
  fetchReportItem: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation()(TransmissionReport);
